import { InjectionToken } from '@angular/core';
import { AppConfig } from './models/app.config';

export const DEFAULT_APP_CONFIG: AppConfig = {
  readableDateFormat: "YYYY-MM-DD",
  dateFormat: "YYYYMMDD",
};

export const APP_CONFIG = new InjectionToken('app.config');
